import script from "./leftPie.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie.vue?vue&type=script&setup=true&lang=js"

import "./leftPie.vue?vue&type=style&index=0&id=e22ff2a8&scoped=true&lang=css"
script.__scopeId = "data-v-e22ff2a8"

export default script